import { Guardian } from '@xaamin/guardian';

Guardian.define('facturas.create', (user) => {
  return user.cliente?.servicios?.cliente_externo !== true;
});